import { render, staticRenderFns } from "./DepartamentoLocalLeitorMonitoramentoList.vue?vue&type=template&id=e2851b06"
import script from "./DepartamentoLocalLeitorMonitoramentoList.vue?vue&type=script&lang=js"
export * from "./DepartamentoLocalLeitorMonitoramentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports